<template>
  <div class="home" id="m1">
    <!-- <van-popup v-model="mshow" position="top" id="m2"> -->
    <van-nav-bar
      title=""
      :left-text="getOrdererDscp()"
      fixed
      placeholder
      @click-left="showOrderer()"
      z-index="2"
    >
      <template #left>
        <van-tag size="large" round type="primary">
          <span class="van-ellipsis" v-if="orderer.potype == 0">外帶</span>
          <span v-if="orderer.potype == 1">外送</span>
        </van-tag>

        <van-tag style="margin-left: 0.3rem" size="large" plain round type="primary">
          <van-icon name="clock-o" />
          <span>{{ orderer.time }}</span>
          <span v-if="orderer.time == ''">現在</span>
        </van-tag>
        <span style="margin-left: 0.3rem">{{ getOrdererDscp() }}</span>
      </template>
    </van-nav-bar>
    <!-- {{ orderer }} -->

    <div v-if="params.runmsg != ''">
      <van-notice-bar scrollable :text="params.runmsg" />
    </div>

    <el-image style="width: 100%" src="./logo.jpg" fit="cover" lazy />

    <!-- <div style="padding: 3rem">
      <hr />
      orderer
      {{ orderer }}
      <hr />
      user
      {{ user }}
      <hr />
      idtoken
      {{ idtoken }}
      <hr />
      params
      
      <hr />
      resdata
      {{ resdata }}
    </div> -->

    <!-- 此行不行刪，刪了時間不會更新 -->
    <div>{{ testno }}</div>
    <!-- {{ params.OpenTime }} -->

    <!-- <div>params:{{ params }}</div> -->
    <!-- <div>{{ getOpenTimeList() }}</div> -->

    <!-- 
    <div>{{ params }}</div>

    <div>點餐時間</div>
    <div>{{ isOpenTime() }}</div>
    <div>取餐時間</div>
    <div>10:30{{ isShipTime("10:30") }}</div>
    <div>11:59{{ isShipTime("11:59") }}</div>
    <div>12:00{{ isShipTime("12:00") }}</div>
    <div>14:30{{ isShipTime("14:30") }}</div>
    <div>23:30{{ isShipTime("23:30") }}</div>
    <div>00:30{{ isShipTime("00:30") }}</div>
    <div>01:30{{ isShipTime("01:30") }}</div>
    <div>07:30{{ isShipTime("07:30") }}</div> -->
    <!-- <div>營業時間{{ params.timeb }}~{{ params.timee }}</div>

    <div>營業{{ isOpenTime() }}</div> -->
    <!-- <div>點餐時間{{ params.timeb }}~{{ params.timee }}</div>
    <div>取餐時間{{ params.shiptimeb }}~{{ params.shiptimee }}</div> -->
    <!-- <van-loading color="#1989fa"  style="margin:3rem"/> -->
    <!-- <div @click="showTop()">top</div> -->
    <Menu :orders="orders" :params="params" :now="now" />
    <!-- </van-popup> -->

    <van-tabbar v-model="active" placeholder v-if="orders.qty > 0">
      <van-button :disabled="!isOpenTime()" type="info" size="large" @click="showCar()">
        <div v-if="isOpenTime()">
          <van-badge :content="orders.qty" max="99">
            <div style="margin-right: 0.5rem">檢視購物清單</div>
          </van-badge>
        </div>
        <div v-else>現在非營業時間</div>
      </van-button>
    </van-tabbar>

    <van-popup
      :close-on-click-overlay="false"
      v-model="frmOrderer.visible"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <van-nav-bar title="取餐方式" placeholder />
      <Orderer :orderer="orderer" :params="params" :now="now" />
      <van-tabbar v-model="active" placeholder>
        <van-button
          type="info"
          :disabled="!checkInputOrderer(orderer)"
          size="large"
          @click="closeOrderer()"
        >
          <span v-if="orderer.tel == ''">請輸入電話號碼</span>
          <span v-else-if="orderer.name == ''">請輸入訂購人名稱</span>
          <span v-else-if="orderer.address == '' && orderer.potype == '1'"
            >請輸入地址</span
          >
          <span v-else>確認</span>
        </van-button>
      </van-tabbar>
    </van-popup>

    <van-popup v-model="frmPo.visible" position="bottom" :style="{ height: '70%' }">
      <van-nav-bar :title="'您有 ' + po.length + ' 筆訂單'" placeholder />
      <!-- {{ po }} -->

      <van-cell
        v-for="p in po"
        :key="p.OrderNo"
        icon="bag"
        is-link
        :label="p.OrderNo"
        @click="showPoList(p)"
      >
        <template #title>
          {{ p.OrderType + " " + p.ShipDate + " " + p.ShipTime }}
        </template>
        <template #default>
          <!-- <span style="color: orangered" v-if="p.Status.indexOf('取消') >= 0">
            訂單已取消
          </span>
          <span v-else>
            <span style="color: orangered" v-if="!isOnLinePayed(p)">
              立即支付 ${{ p.PoAmt }}
            </span>
            <span v-else>{{ "$" + p.PoAmt }}</span>
          </span> -->
          <span style="color: orangered" v-if="!isOnLinePayed(p)">
            立即支付 ${{ p.PoAmt }}
          </span>
          <span v-else>{{ "$" + p.PoAmt }}</span>
        </template>
      </van-cell>

      <van-tabbar v-model="active" placeholder>
        <van-button type="info" size="large" @click="closePO()">關閉</van-button>
      </van-tabbar>
    </van-popup>

    <van-popup v-model="frmPoList.visible" position="bottom" :style="{ height: '70%' }">
      <van-nav-bar :title="cntList.OrderType" placeholder />

      <!-- {{cntList}} -->
      <div style="padding: 0.5rem">
        <div>訂單號碼：{{ cntList.OrderNo }}</div>
        <div>
          取餐時間：<span v-if="cntList.ShipTime == ''">現在</span>
          <span v-if="cntList.ShipTime != ''"
            >{{ cntList.ShipDate }} {{ cntList.ShipTime }}</span
          >
        </div>
        <div>
          顧客名稱：{{ cntList.CustName }}
          <span v-if="cntList.TEL1 != ''">({{ cntList.TEL1 }})</span>
        </div>
        <div>
          付款方式：{{ cntList.PayType }} ${{ cntList.PoAmt }}
          <span style="color: orangered" v-if="!isOnLinePayed(cntList)">(尚未付款)</span>
        </div>
        <div>訂單狀態：{{ dispPoStatus(cntList) }}</div>
      </div>
      <!-- {{ cntList.NewebPay }} -->
      <form
        :id="cntList.OrderNo"
        :name="cntList.OrderNo"
        :action="cntList.NewebPay.GetWay"
        method="POST"
        v-if="cntList.NewebPay != undefined"
      >
        <input type="hidden" name="MerchantID" :value="cntList.NewebPay.MerchantID" />
        <input type="hidden" name="TradeInfo" :value="cntList.NewebPay.TradeInfo" />
        <input type="hidden" name="TradeSha" :value="cntList.NewebPay.TradeSha" />
        <input type="hidden" name="Version" value="1.6" />
      </form>

      <!-- <div style="margin: 1rem" v-if="cntList.Status != '取消'"> -->
      <div style="margin: 1rem">
        <van-button
          type="info"
          size="large"
          v-if="cntList.PayType == 'LINEPAY線上' && !isOnLinePayed(cntList)"
          @click="useLinePay(cntList.OrderNo, cntList.PoAmt)"
          >使用LINEPAY付款 ${{ cntList.PoAmt }}</van-button
        >
        <van-button
          type="info"
          size="large"
          v-if="cntList.PayType == '信用卡' && !isOnLinePayed(cntList)"
          @click="useNewebPay(cntList)"
          >使用信用卡付款 ${{ cntList.PoAmt }}</van-button
        >
      </div>

      <div style="padding: 0.5rem" v-for="ls in cntList.PO_I" :key="ls.ItemName">
        <van-row v-if="ls.Qty > 0">
          <van-col span="2" align="center">
            <span
              style="font-weight: bold"
              v-if="ls.ItemType != 'S2' && ls.ItemType != 'A1'"
              >{{ ls.Qty }}</span
            >
          </van-col>

          <van-col span="18">
            <!-- {{ls}} -->
            <div style="color: black">
              {{ ls.ItemName }}
              <span v-if="ls.ItemType == 'S2' || ls.ItemType == 'A1'">
                <span v-if="ls.Qty > 1"> X {{ ls.Qty }} </span>
              </span>
            </div>
            <div style="color: #666">{{ ls.Remark }}</div>
          </van-col>

          <van-col span="4" align="right"> ${{ ls.Amt }} </van-col>
        </van-row>
      </div>
      <van-tabbar v-model="active" placeholder>
        <van-button type="info" size="large" @click="frmPoList.visible = false"
          >返回</van-button
        >
      </van-tabbar>
    </van-popup>

    <van-popup v-model="frmCheck.visible" position="top">
      <h1>frmCheck</h1>
      <el-button type="primary" @click="frmCheck.visible = false">continue</el-button>
    </van-popup>

    <van-popup v-model="frmCar.visible" position="top">
      <van-nav-bar left-text="返回" left-arrow fixed placeholder @click-left="closeCar()">
        <template #title>
          <div style="color: #333; font-size: 1.1rem">
            <span v-if="orderer.potype == 0">外帶</span>
            <span v-if="orderer.potype == 1">外送</span>
            <span>{{ orderer.time }}</span>
          </div>
        </template>
      </van-nav-bar>

      <Car :list="list" :orderer="orderer" :params="params" />

      <!-- <hr /> -->
      <!-- {{params.OrderTimes}}  -->

      <!-- {{ JSON.stringify(checkOrderTime(orderer.date, orderer.time)) }} -->
      <!-- <div @click="checkOrderTime(orderer.date, orderer.time)">
        {{ orderer.date }} {{ orderer.time }}
      </div> -->

      <!-- {{objCredit}} -->
      <form
        :id="objCredit.OrderNo"
        :name="objCredit.OrderNo"
        :action="objCredit.GetWay"
        method="POST"
        v-if="objCredit != undefined"
      >
        <input type="hidden" name="MerchantID" :value="objCredit.MerchantID" />
        <input type="hidden" name="TradeInfo" :value="objCredit.TradeInfo" />
        <input type="hidden" name="TradeSha" :value="objCredit.TradeSha" />
        <input type="hidden" name="Version" value="1.6" />
      </form>

      <van-tabbar v-model="active" placeholder>
        <van-button
          type="info"
          :disabled="!beforeSendDataCheck()"
          size="large"
          :loading="frmCar.loading"
          @click="send()"
        >
          <div v-if="beforeSendDataCheck()">
            <!-- <div v-if="getCheckSum() > 0"> -->
            <!-- {{params.ShipMinQty}} / {{list.length}} -->
            <span>金額${{ getCheckSum() }} , </span>
            <span v-if="orderer.paytype == 1">傳送訂單</span>
            <span v-if="orderer.paytype == 2">使用LINE PAY付款</span>
            <span v-if="orderer.paytype == 3">使用信用卡付款</span>
            <!-- <span v-if="orderer.paytype == ''">請先選擇付款方式</span> -->
            <!-- </div> -->
            <!-- <div v-else>訂單金額必須大於金額0</div> -->
          </div>
          <div v-else>
            {{ beforeSendDataCheckErrMsg() }}
          </div>
        </van-button>
      </van-tabbar>
    </van-popup>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-popup {
  height: 100%;
}
.carbox {
  border-radius: 40px 0px 0px 40px;
  background: rgba(19, 89, 250, 0.9);
  float: right;
  height: 4rem;
  width: 5rem;
  border: 2px 0 2px 0 #666 solid;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
// import Hello from "@/components/Hello.vue";
import Menu from "@/components/Menu.vue";
import Car from "@/components/Car.vue";
import Orderer from "@/components/Orderer.vue";
// import CheckUser from "@/components/CheckUser.vue";
// import Dialog from "@/components/Dialog.vue";
// import menutype from "@/components/json/menutype.json";
// import menuitem from "@/components/json/menuitem.json";
// import { Dialog } from 'vant';
export default {
  name: "Home",
  components: {
    // HelloWorld,
    // Hello,
    Orderer,
    Menu,
    Car,
  },
  data() {
    return {
      frmOrderer: { visible: false },
      frmCar: { visible: false, loading: false },
      frmCheck: { visible: false },
      frmItem: { visible: false },
      frmPo: { visible: false },
      frmPoList: { visible: false },
      orderer: {
        potype: "",
        name: "",
        tel: "",
        time: "",
        now: {},
        address: "",
        remark: "",
        userid: "",
        displayname: "",
        paytype: "",
        tableware: false,
        shipamt: 0,
        poamt: 0,
        carrier: "",
        bno: "",
      },
      user: {},
      params: {},
      list: [],
      show1: true,
      // menutype: menutype,
      // menuitem: menuitem,
      loading1: false,
      orders: { qty: 0 },
      po: [],
      cntList: {},
      idtoken: {},
      acctoken: {},
      resdata: {},
      testno: "",
      test: "",
      mshow: true,
      objCredit: {},
    };
  },
  beforeMount: function () {
    this.initApp();
  },

  created() {
    setInterval(() => {
      this.testno++;
      this.testno = "";
      var dt = new Date();
      var row = {};
      row.time = dt.getHours() + ":" + dt.getMinutes();
      row.fulltime = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
      row.hh = dt.getHours();
      row.mm = dt.getMinutes();
      row.ss = dt.getSeconds();
      row.weekday = dt.getDay();
      // var mm = Number(dt.getMonth()) + 1;
      var mm = Number(dt.getMonth());
      row.date = dt.getFullYear() + "/" + mm + "/" + dt.getDate();
      this.now = row;

      this.params.WeekOpenTime = this.sortWeekOpenTime();
      // this.params.OpenTime = this.getOpenTimeList();
      this.params.OpenTime = [];
    }, 1000);
  },

  methods: {
    initApp() {
      document.title = "";
      if (window.location.hostname == "localhost") {
        this.user.userId = "IDSA";
      } else {
        // this.login();
      }

      var app = this;
      app.user = {};

      app.$http
        .get("./getParam")
        .then((response) => {
          app.params = response.data;

          document.title = app.params.storeid;

          app.appLogin(app.params.liff_id, app.params.addFriendUrl, function (err, data) {
            if (data == undefined) {
              app.$dialog
                .alert({
                  message: "請加入官方帳號好友進行點餐",
                })
                .then(() => {
                  window.location = app.params.addFriendUrl;
                });
              return;
            }
            app.user = data;
            app.orderer.userid = data.userId;
            app.orderer.name = data.displayName.substr(0, 10);
            app.orderer.displayname = data.displayName;
            app.orderer.date = "";

            // alert(JSON.stringify(app.user));
            app.getListQty();
            app.$http
              .post("./getJsonUser", { user: app.orderer })
              .then((response) => {
                var name = response.data.name;
                if (name != undefined) {
                  app.orderer.name = name;
                }
                var tel = response.data.tel;
                if (tel != undefined) {
                  app.orderer.tel = tel;
                }
              })
              .catch(function (error) {
                console.log(error);
              });
            app.$http
              .get("./po", { params: { uid: app.user.userId } })
              .then((response) => {
                app.po = response.data;
                if (app.po.length > 0) {
                  app.frmPo.visible = true;
                }
              })
              .catch(function (error) {
                console.log(error);
                app.po = [];
              });
          });
        })
        .catch(function (error) {
          console.log(error);
          app.params = {};
        });
    },
    sortWeekOpenTime() {
      var newData = [];
      var weekday = this.now.weekday;
      var list = [];
      switch (weekday) {
        case 0:
          list = [0, 1, 2, 3, 4, 5, 6];
          break;
        case 1:
          list = [1, 2, 3, 4, 5, 6, 0];
          break;
        case 2:
          list = [2, 3, 4, 5, 6, 0, 1];
          break;
        case 3:
          list = [3, 4, 5, 6, 0, 1, 2];
          break;
        case 4:
          list = [4, 5, 6, 0, 1, 2, 3];
          break;
        case 5:
          list = [5, 6, 0, 1, 2, 3, 4];
          break;
        case 6:
          list = [6, 0, 1, 2, 3, 4, 5];
          break;
        default:
          break;
      }
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < this.params.WeekOpenTime.length; j++) {
          if (list[i] == this.params.WeekOpenTime[j].weekday) {
            var day = this.params.WeekOpenTime[j];
            newData.push(day);
            break;
          }
        }
      }
      return newData;
    },
    appLogin(liffId, addFriendUrl, callback) {
      var app = this;
      // alert("liffId:" + liffId);
      if (liffId == "" || liffId == undefined) {
        app.$http.get("./getuser").then((response) => {
          if (response.data == "" || response.data == undefined) {
            window.location = "./login";
          } else {
            callback(null, response.data);
          }
        });
      } else {
        window.liff
          .init({
            liffId: liffId,
          })
          .then(() => {
            // app.acctoken = window.liff.getAccessToken();
            var data = window.liff.getDecodedIDToken();
            // alert("data:" + data);
            if (data == null || data == undefined) {
              app.$dialog
                .alert({
                  message: "使用線上點餐,需先加入官方帳號",
                })
                .then(() => {
                  window.location = app.params.addFriendUrl;
                });
            }
            // app.idtoken = data;
            //     // { "userId": "Uddbcb9cbab56c86bd116f2152b15091e", "displayName": "Darren", "pictureUrl": "https://profile.line-scdn.net/0m00dad486725149aae9778c77d803b7f3f65e402ea72e" }

            window.liff
              .getProfile()
              .then((profile) => {
                // alert("profile:" + profile);
                app.idtoken = profile;
                var user = {};
                user.userId = app.idtoken.userId;
                user.displayName = app.idtoken.displayName;
                user.pictureUrl = app.idtoken.pictureUrl;

                window.liff.getFriendship().then((data1) => {
                  app.resdata = data1;
                  if (!data1.friendFlag) {
                    app.$dialog.alert({
                      message: "使用線上點餐,需先加入官方帳號",
                    });
                    window.location = addFriendUrl;
                  } else {
                    callback(null, user);
                  }
                });
              })
              .catch((err) => {
                console.log("error", err);
              });
          })
          .catch((err) => {
            console.log(err);
            alert(err);
            callback(err);
          });
      }
    },
    showCar() {
      var app = this;
      if (app.orderer.tel == "") {
        app.$dialog
          .alert({
            message: "請填寫連絡電話(必填)",
          })
          .then(() => {
            app.frmOrderer.visible = true;
          });

        return;
      }
      if (app.params.NeedTime) {
        if (app.orderer.time == "") {
          app.$dialog
            .alert({
              message: "請選擇取餐時間(必填)",
            })
            .then(() => {
              app.frmOrderer.visible = true;
            });

          return;
        }
      }

      if (app.orderer.potype == 0) {
        app.orderer.shipamt = 0;
      } else {
        // app.orderer.shipamt = 99;
        app.orderer.shipamt = Number(app.params.ShipAmt);
      }
      app.$http
        .get("./list")
        .then((response) => {
          app.list = response.data;
          // alert(app.list.length);
          if (app.list.length > 0) {
            app.frmCar.visible = true;
          }
        })
        .catch(function (error) {
          app.$dialog.alert({
            message: error,
          });
          app.frmCar.visible = true;
        });
    },
    closeCar() {
      var app = this;
      app.$http
        .post("./updList", { items: app.list })
        .then((response) => {
          console.log(response);
          app.getListQty();
          app.frmCar.visible = false;
        })
        .catch(function (error) {
          app.$dialog.alert({
            message: error,
          });
        });
    },
    getListQty() {
      var app = this;
      app.$http
        .get("./list")
        .then((response) => {
          let data = response.data;
          let qty = 0;
          for (let i = 0; i < data.length; i++) {
            qty += data[i].Qty;
          }
          app.orders.qty = qty;
        })
        .catch(function (error) {
          console.log(error);
          app.orders.qty = 0;
        });
    },
    send() {
      var app = this;

      if (this.checkData() == false) {
        return;
      }

      if (app.checkOrderTime(app.orderer.date, app.orderer.time) == false) {
        app.$dialog
          .alert({
            message: "請重新選擇取餐時間",
          })
          .then(() => {
            app.orderer.date = "";
            app.orderer.time = "";
            app.showOrderer();
          });
        return;
      }

      if (app.params.NeedTime) {
        if (app.orderer.time == "") {
          app.$dialog
            .alert({
              message: "請選擇取餐時間(必填)",
            })
            .then(() => {
              // app.frmOrderer.visible = true;
              app.showOrderer();
            });

          return;
        }
      }

      var discountAmt = app.getDiscountAmt();
      app.frmCar.loading = true;
      app.orderer.discountAmt = discountAmt;
      app.orderer.poamt = app.getCheckSum();
      app.$http
        .post("./send", { items: app.list, orderer: app.orderer })
        .then((response) => {
          var err = response.data.errno;

          if (err != undefined) {
            app.$dialog
              .alert({
                message: "傳送失敗:" + JSON.stringify(err),
              })
              .then(() => {
                app.frmCar.loading = false;
              });
          } else {
            // app.list = [];

            app.objCredit = response.data.credit;

            var newLine = String.fromCharCode(13) + String.fromCharCode(10);
            var url = window.location.protocol;
            url += "//" + window.location.hostname;
            url += "/pno/" + response.data.orderno;
            var text = "訂單：";
            if (app.orderer.potype == 0) {
              text += "外帶自取";
            } else {
              text += "外送";
            }
            text += "($" + response.data.sumamt + ")" + newLine;
            text += "取餐單號:" + response.data.orderno + newLine;

            var shiptime = app.orderer.time;
            if (shiptime == "" || shiptime == undefined) {
              shiptime = "現在";
            }
            text += "取餐時間:" + shiptime + newLine;
            text += url;
            if (app.params.liff_id != undefined && app.params.liff_id != "") {
              window.liff
                .sendMessages([
                  {
                    type: "text",
                    text: text,
                  },
                ])
                .then(() => {
                  console.log("message sent");
                })
                .catch((err) => {
                  console.log("error", err);
                  // 當user取消允許傳送訊息至聊天室時會出現
                  // "Error:user doesn't grant required permissions yet"
                  // alert(err);
                });
            }

            if (app.orderer.paytype == 1) {
              //取餐付款
              app.$dialog.alert({ message: "訂單建立成功" }).then(() => {
                window.location.reload();
              });
            } else if (app.orderer.paytype == 2) {
              //linepay
              app.$dialog
                .alert({ message: "訂單建立成功", confirmButtonText: "下一步" })
                .then(() => {
                  app.$dialog.alert({ message: "請按確認進行LINEPAY付款" }).then(() => {
                    var orderno = response.data.orderno;
                    var sumamt = response.data.sumamt;
                    // alert(response.data);
                    window.location.href =
                      "./linepay?ono=" + orderno + "&amt=" + Number(sumamt);

                    app.useLinePay(orderno, sumamt);
                  });
                });
            } else if (app.orderer.paytype == 3) {
              //CreditPay
              app.$dialog.alert({ message: "請按確認進行信用卡付款" }).then(() => {
                var orderno = response.data.orderno;
                var sumamt = response.data.sumamt;
                // app.useCreditPay(orderno, sumamt);
                // alert(JSON.stringify(credit));
                let row = {};
                row.OrderNo = orderno;
                row.PoAmt = sumamt;
                app.useNewebPay(row);
              });
            }
          }
        })
        .catch(function (error) {
          app.$dialog.alert({
            message: error,
          });
          app.frmCar.loading = false;
        });
    },
    showOrderer: function () {
      var app = this;
      if (!this.isOpenTime()) {
        app.$dialog
          .alert({
            message: "現在非營業時間",
          })
          .then(() => {
            // app.frmOrderer.visible = false;
          });

        return;
      }

      app.$http
        .post("./getJsonUser", { user: app.orderer })
        .then((response) => {
          console.log(response);
          // alert(JSON.stringify(response.data));
          var tel = response.data.tel;
          if (tel != undefined) {
            app.orderer.tel = tel;
          }
          var name = response.data.name;
          if (name != undefined) {
            app.orderer.name = name;
          }
          var address = response.data.address;
          if (address != undefined) {
            app.orderer.address = address;
          }
          app.frmOrderer.visible = true;
        })
        .catch(function (error) {
          console.log(error);
          app.frmOrderer.visible = true;
        });
    },
    closeOrderer: function () {
      var app = this;
      app.$http
        .post("./setUser", { user: app.orderer })
        .then((response) => {
          console.log(response);
          this.frmOrderer.visible = false;
        })
        .catch(function (error) {
          console.log(error);
          this.frmOrderer.visible = false;
        });
    },

    getOrdererDscp: function () {
      var str = "";
      if (this.orderer.potype == 0) {
        //  str += "外帶 ";
        str += this.orderer.name + "來店自取";
      } else {
        //  str += "外送 ";
        //  str += this.orderer.time + "";
        str += "送至" + this.orderer.address;
      }
      return str;
    },
    isOpenTime: function () {
      var timeb = {};
      var timee = {};
      if (this.params.timeb == undefined) {
        return true;
      }
      timeb.hh = Number(this.params.timeb.substr(0, 2));
      timeb.mm = Number(this.params.timeb.substr(3, 2));
      timee.hh = Number(this.params.timee.substr(0, 2));
      timee.mm = Number(this.params.timee.substr(3, 2));

      var hh = this.now.hh;
      var mm = this.now.mm;

      if (timee.hh > timeb.hh) {
        //沒有跨日
        if (hh < timeb.hh) {
          return false;
        }

        if (hh > timee.hh) {
          return false;
        }

        if (hh == timeb.hh) {
          if (mm < timeb.mm) {
            return false;
          }
        }

        if (hh == timee.hh) {
          if (mm > timee.mm) {
            return false;
          }
        }
      } else if (timee.hh < timeb.hh) {
        //跨日營業

        if (hh < timeb.hh && hh > timee.hh) {
          return false;
        }

        if (hh > timee.hh && hh < timeb.hh) {
          return false;
        }

        if (hh == timeb.hh) {
          if (mm < timeb.mm) {
            return false;
          }
        }

        if (hh == timee.hh) {
          if (mm > timee.mm) {
            return false;
          }
        }
      }
      return true;
    },

    isShipTime: function (time) {
      if (time == "" || time == undefined) {
        return true;
      }
      if (this.params.shiptimeb == undefined) {
        return true;
      }
      var timeb = {};
      var timee = {};
      var hh = Number(time.substr(0, 2));
      var mm = Number(time.substr(3, 2));

      timeb.hh = Number(this.params.shiptimeb.substr(0, 2));
      timeb.mm = Number(this.params.shiptimeb.substr(3, 2));
      timee.hh = Number(this.params.shiptimee.substr(0, 2));
      timee.mm = Number(this.params.shiptimee.substr(3, 2));

      if (timee.hh > timeb.hh) {
        //沒有跨日
        if (hh < timeb.hh) {
          return false;
        }

        if (hh > timee.hh) {
          return false;
        }

        if (hh == timeb.hh) {
          if (mm < timeb.mm) {
            return false;
          }
        }

        if (hh == timee.hh) {
          if (mm > timee.mm) {
            return false;
          }
        }
      } else if (timee.hh < timeb.hh) {
        //跨日營業

        if (hh < timeb.hh && hh > timee.hh) {
          return false;
        }

        if (hh > timee.hh && hh < timeb.hh) {
          return false;
        }

        if (hh == timeb.hh) {
          if (mm < timeb.mm) {
            return false;
          }
        }

        if (hh == timee.hh) {
          if (mm > timee.mm) {
            return false;
          }
        }
      }
      return true;
    },
    isVailTime: function (pTime, pTimeb, pTimee) {
      var hh = Number(pTime.substr(0, 2));
      var mm = Number(pTime.substr(3, 2));
      var timeb = {};
      var timee = {};
      timeb.hh = Number(pTimeb.substr(0, 2));
      timeb.mm = Number(pTimeb.substr(3, 2));
      timee.hh = Number(pTimee.substr(0, 2));
      timee.mm = Number(pTimee.substr(3, 2));
      if (timee.hh > timeb.hh) {
        //沒有跨日
        if (hh < timeb.hh) {
          return false;
        }
        if (hh > timee.hh) {
          return false;
        }
        if (hh == timeb.hh) {
          if (mm < timeb.mm) {
            return false;
          }
        }
        if (hh == timee.hh) {
          if (mm > timee.mm) {
            return false;
          }
        }
      } else if (timee.hh < timeb.hh) {
        //跨日營業
        if (hh < timeb.hh && hh > timee.hh) {
          return false;
        }
        if (hh > timee.hh && hh < timeb.hh) {
          return false;
        }
        if (hh == timeb.hh) {
          if (mm < timeb.mm) {
            return false;
          }
        }
        if (hh == timee.hh) {
          if (mm > timee.mm) {
            return false;
          }
        }
      }
      return true;
    },
    isWeekOpenTime: function (time) {
      console.log(time);
      var weekday = this.now.weekday;
      var day = {};
      for (let i = 0; i < this.params.WeekOpenTime.length; i++) {
        day = this.params.WeekOpenTime[i];
        if (day.weekday == weekday) {
          break;
        }
      }
      var tmp = "88";
      for (let i = 0; i < day.openTime.length; i++) {
        let times = day.openTime[i];
        let timeb = times.timeb;
        let timee = times.timee;
        var hhmm = this.now.time;
        tmp += "now is " + hhmm;
        tmp += ", in time " + timeb + "~" + timee;
        tmp += ":" + this.isVailTime(this.now.time, timeb, timee);
        tmp += " | ";
      }
      console.log(tmp);

      return tmp;
    },
    dateAdd(datetime, min) {
      var dt = new Date();
      dt.setTime(datetime.getTime() + min * 60 * 1000);
      return dt;
    },
    getTimeSplit(date, timeb, timee) {
      // date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth();
      var d = date.getDate();
      var tb = {};
      var te = {};
      tb.hh = Number(timeb.substr(0, 2));
      tb.mm = Number(timeb.substr(3, 2));
      te.hh = Number(timee.substr(0, 2));
      te.mm = Number(timee.substr(3, 2));
      var dateb = new Date(y, m, d, tb.hh, tb.mm);
      var datee = new Date(y, m, d, te.hh, te.mm);
      if (te.hh < tb.hh) {
        datee = this.dateAdd(datee, 24 * 60);
      }
      var time = dateb;
      var list = [];
      while (time <= datee) {
        var row = {};
        y = time.getFullYear();
        // m = time.getMonth() + 1;
        m = time.getMonth();
        d = time.getDate();
        var hh = time.getHours();
        var mm = time.getMinutes();

        if (hh < 10) {
          hh = "0" + hh;
        }
        if (mm < 10) {
          mm = "0" + mm;
        }

        if (m < 10) {
          m = "0" + m;
        }
        if (d < 10) {
          d = "0" + d;
        }

        row.ymd = y + "/" + m + "/" + d;
        row.hm = hh + ":" + mm;
        let timestep = 15;
        if (Number(this.params.TimeStep) >= 5) {
          timestep = Number(this.params.TimeStep);
        }
        time = this.dateAdd(time, timestep);
        list.push(row);
      }

      return list;
    },
    getOpenTimeList: function () {
      var app = this;
      var list = [];
      var week = this.params.WeekOpenTime;
      var now = new Date();
      var date = now;
      list = [];

      date = app.dateAdd(date, -24 * 60); //先抓前一天有沒有跨24小時營業
      var shipdays = 2; // 前一天跨24小時&今天
      shipdays += Number(app.params.ShipDays);

      for (let h = 0; h < shipdays; h++) {
        //取得可訂餐時段
        var weekday = date.getDay();
        for (let i = 0; i < week.length; i++) {
          if (weekday == week[i].weekday) {
            for (let j = 0; j < week[i].openTime.length; j++) {
              let timeb = week[i].openTime[j].timeb;
              let timee = week[i].openTime[j].timee;
              let tmp = [];
              tmp = app.getTimeSplit(date, timeb, timee);
              list = list.concat(tmp);
            }
          }
        }

        date = app.dateAdd(date, 24 * 60);
      }

      var data = [];
      var days = [];
      for (let i = 0; i < list.length; i++) {
        let ymd = list[i].ymd;

        if (days.indexOf(ymd) < 0) {
          days.push(ymd);
          var row = {};
          row.ymd = ymd;
          var times = [];
          for (let j = 0; j < list.length; j++) {
            let hm = list[j].hm;
            if (list[j].ymd == row.ymd) {
              if (times.indexOf(hm) < 0) {
                times.push(hm);
              }
            }
          }
          times.sort();
          row.hm = times;

          let y = row.ymd.toString().substr(0, 4);
          let m = Number(row.ymd.toString().substr(5, 2));
          let d = row.ymd.toString().substr(8, 2);
          let date1 = new Date(y, m, d, 23, 59, 59);
          // row.y = date1;
          // row.now = now;
          if (date1 >= now) {
            data.push(row);
          }
        }
      }

      return data;
    },
    getTimeDscp: function (date) {
      return date;
    },
    checkData: function () {
      var bno = this.orderer.bno;
      var carrier = this.orderer.carrier;

      if (bno == undefined) {
        bno = "";
      }
      if (carrier == undefined) {
        carrier = "";
      }

      if (bno != "") {
        if (bno.length != 8) {
          this.$dialog.alert({ message: "統編長度錯誤" });
          return false;
        } else {
          if (isNaN(Number(bno))) {
            this.$dialog.alert({ message: "統編格式錯誤" });
            return false;
          }
        }
      }

      if (carrier != "") {
        if (carrier.length != 8) {
          this.$dialog.alert({ message: "載具長度錯誤" });
          return false;
        } else {
          var word = carrier.substring(0, 1);
          if (word != "/") {
            this.$dialog.alert({ message: "載具格式錯誤" });
            return false;
          }
        }
      }
      return true;
      // if (this.list.length == 0) {
      //   return false;
      // }
      // if (this.getCheckSum() <= 0) {
      //   return false;
      // }

      // if (
      //   this.orderer.paytype == "" ||
      //   this.orderer.paytype == "0" ||
      //   this.orderer.paytype == undefined
      // ) {
      //   return false;
      // }

      // return true;
    },
    getItemSum(obj) {
      let amt = Number(obj.Price1);
      var notes = obj.Notes;
      if (notes != undefined) {
        for (let i = 0; i < notes.length; i++) {
          if (notes[i].value) {
            if (Number(notes[i].Remark > 0)) {
              amt += Number(notes[i].Remark);
            }
          }
        }
      }
      let s2 = obj.S2;

      for (let i = 0; i < s2.length; i++) {
        let items = s2[i].items;
        for (let j = 0; j < items.length; j++) {
          let item = items[j];
          // alert(item);
          if (item.value) {
            let qty = Number(item.value);
            amt += Number(item.Price) * qty;
            if (items[j].ItemType == "SS") {
              var s3 = items[j].S2;
              for (let k = 0; k < s3.length; k++) {
                var s3items = s3[k].items;
                for (let l = 0; l < s3items.length; l++) {
                  if (s3items[l].value) {
                    let s3qty = Number(s3items[l].value);
                    amt += Number(s3items[l].Price) * s3qty;
                  }
                }
              }
            }
          }
        }
      }
      amt *= obj.Qty;
      return amt;
    },
    getTotalSum() {
      let list = this.list;
      let amt = 0;
      let sum = 0;
      for (let i = 0; i < list.length; i++) {
        let ls = list[i];
        amt = this.getItemSum(ls);
        sum += amt;
      }
      return sum;
    },
    getDiscountAmt() {
      if (this.params.DiscountRate <= 0 || this.params.DiscountRate == undefined) {
        return 0;
      }
      var rate = (100 - this.params.DiscountRate) * 0.01;
      var sum = this.getTotalSum();
      if (sum <= 0) {
        return 0;
      }
      var discountAmt = sum * rate;
      discountAmt = parseInt(discountAmt);
      if (discountAmt > sum) {
        discountAmt = sum;
      }
      return discountAmt;
    },
    getCheckSum() {
      var amt = 0;
      amt += this.getTotalSum();
      amt -= this.getDiscountAmt();
      amt += this.orderer.shipamt;
      return amt;
    },

    showPoList(polist) {
      this.cntList = polist;
      this.frmPoList.visible = true;
    },

    useLinePay(orderno, amt) {
      var url = "./linepay?ono=" + orderno + "&amt=" + Number(amt);
      window.location.href = url;
    },

    useCreditPay(orderno, amt) {
      var url = "./creditpay?ono=" + orderno + "&amt=" + Number(amt);
      window.location.href = url;
    },

    useNewebPay(obj) {
      // var url = "./creditpay?ono=" + orderno + "&amt=" + Number(amt);
      // window.location.href = url;
      // var f1 = document.getElementById("f1");
      // alert("creditpay:" + obj.OrderNo);
      document.getElementById(obj.OrderNo).submit();
      // document.getElementById("form1" ).submit();
      // alert("useNewebPay" + obj.OrderNo + obj.PoAmt);
    },

    closePO() {
      var app = this;
      app.frmPo.visible = false;
      // if (app.orderer.tel == "") {
      //   app.frmOrderer.visible = true;
      // }
    },

    showTop() {
      var m1 = document.getElementById("m1");
      alert(m1.scrollTop);
      var m2 = document.getElementById("m2");
      alert(m2.scrollTop);
      m2.scrollTo(0, 600);
      // if (m1 != null) {
      //   m1.scrollTo(0, 0);
      // }
    },
    getListSumQty() {
      let sum = 0;
      for (let i = 0; i < this.list.length; i++) {
        sum += this.list[i].Qty;
      }
      return sum;
    },
    beforeSendDataCheck() {
      if (this.list.length == 0) {
        return false;
      }

      if (this.getCheckSum() <= 0) {
        return false;
      }

      if (this.orderer.potype == 1) {
        if (this.orderer.address == "" || this.orderer.address == undefined) {
          return false;
        }

        if (this.params.ShipMinQty > 0) {
          if (this.getListSumQty() < this.params.ShipMinQty) {
            return false;
          }
        }
      }

      if (
        this.orderer.paytype == "" ||
        this.orderer.paytype == "0" ||
        this.orderer.paytype == undefined
      ) {
        return false;
      }

      return true;
    },
    beforeSendDataCheckErrMsg() {
      let msg = "";

      if (this.list.length == 0) {
        msg = "請先選擇餐點";
        return msg;
      }

      if (this.getCheckSum() <= 0) {
        msg = "訂單金額必須大於金額0";
        return msg;
      }

      if (this.orderer.potype == 1) {
        if (this.orderer.address == "" || this.orderer.address == undefined) {
          msg = "外送地址不得為空值";
          return msg;
        }

        if (this.params.ShipMinQty > 0) {
          if (this.getListSumQty() < this.params.ShipMinQty) {
            msg = "外送餐點需達" + this.params.ShipMinQty + "份,";
            msg += "已選" + this.getListSumQty() + "份";
            return msg;
          }
        }
      }

      if (
        this.orderer.paytype == "" ||
        this.orderer.paytype == "0" ||
        this.orderer.paytype == undefined
      ) {
        msg = "請先選擇付款方式";
        return msg;
      }

      return msg;
    },
    isOnLinePayed(po) {
      if (po.PayedAmt != po.PoAmt) {
        if (po.PayType == "LINEPAY線上") {
          return false;
        }
        if (po.PayType == "信用卡") {
          return false;
        }
      }

      return true;
    },
    dispPoStatus(po) {
      if (po.Status == "") {
        return "已建立";
      }

      if (po.Status == "已付訂") {
        return "付款成功";
      }

      if (po.Status == "取消") {
        if (po.PayType == "LINEPAY線上") {
          return "待付款";
        }
        if (po.PayType == "信用卡") {
          return "待付款";
        }

        return "已取消";
      }

      return po.Status;
    },
    checkOrderTime(pDate, pTime) {
      console.log(pDate + "," + pTime);
      var app = this;
      let times = app.params.OrderTimes;
      // let data = [];
      let isVaildTime = true;
      times.forEach((date) => {
        let ymd = date.ymd;
        let row = {};
        row.text = ymd;
        row.children = [];

        date.times.forEach((t) => {
          let row1 = {};
          row1.text = t.time;
          row1.count = t.count;
          row1.disabled = false;
          let y = ymd.toString().substr(0, 4);
          let m = Number(ymd.toString().substr(5, 2)) - 1;
          let d = ymd.toString().substr(8, 2);
          let hh = t.time.toString().substr(0, 2);
          let mm = t.time.toString().substr(3, 2);
          // alert( y  + " " +  m  + " " +  d  + " " +  hh + " " +  mm);
          let dt = new Date(y, m, d, hh, mm);
          let now = new Date();
          if (dt < app.dateAdd(now, app.params.SetupTime)) {
            row1.text = t.time + " 訂滿";
            row1.disabled = true;
          }

          if (app.params.LimitCount > 0) {
            if (row1.count >= app.params.LimitCount) {
              row1.text = t.time + " 訂滿";
              row1.disabled = true;
            }
          }

          if (pDate == ymd && pTime == t.time && row1.disabled == true) {
            isVaildTime = false;
          }
        });
      });
      // isVaildTime = false;
      // alert(isVaildTime);
      return isVaildTime;
    },
    checkInputOrderer(obj) {
      if (obj.tel == "") {
        return false;
      }

      if (obj.address == "" && obj.potype == "1") {
        return false;
      }

      return true;
    },
  },
};
</script>
